/**
 * Frontend editor script
 */
